// client/menu-items/DeleteSelectedNode.ts
import "@adornis/chemistry/elements/components/x-icon";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { isNodeSelection } from "../util.js";
var DeleteSelectedNodeMenuItem = {
  label: "L\xF6schen",
  icon: "delete",
  run: async (view) => {
    const { state, dispatch } = view;
    if (!isNodeSelection(state.selection) || !await XDialog.confirm("Willst du dieses Element wirklich l\xF6schen?")) {
      return;
    }
    const { from, to } = state.selection;
    const { tr } = view.state;
    tr.delete(from, to);
    dispatch(tr);
  },
  shouldVisualize: (view) => {
    return isNodeSelection(view.state.selection);
  }
};
export {
  DeleteSelectedNodeMenuItem
};
